/* @flow */

import React from 'react';
import { withRouter } from 'react-router-dom';
import { Menu, Button, Input } from 'semantic-ui-react';

type Props = {
  folder: BucketFolder,
  history: Object,
  onSearch: (value: string) => void,
};

const styles = {
  input: {
    width: '200px',
  },
};

const FolderHeader = ({ folder, history, onSearch }: Props) => {
  const search = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onSearch(event.target.value);
    }
  };

  const goBack = () => history.goBack();

  return (
    <div className="ui secondary menu segment actions">
      <Menu.Item>
        <Button
          onClick={goBack}
          basic
          labelPosition="left"
          icon="chevron circle left"
          content="Retour à la liste"
        />
      </Menu.Item>
      <Menu.Menu position="right">
        <Menu.Item>
          <Input
            style={styles.input}
            fluid
            onChange={search}
            icon="search"
            iconPosition="left"
            placeholder="Recherche..."
          />
        </Menu.Item>
      </Menu.Menu>
    </div>
  );
};

export default withRouter(FolderHeader);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/FolderHeader.js